module.exports = __webpack_public_path__ + "empty@2x.8c5662c.png";